import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../state";
import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { PayloadAction } from "@reduxjs/toolkit";

export enum SeverityTypes {
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
  SUCCESS = "success",
}

export interface DialogData {
  open: boolean;
  scroll: "body" | "paper" | undefined;
  title: string | ReactJSXElement | undefined;
  content: any;
  actions: Array<ReactJSXElement>;
  reload: boolean;
  size: DialogSize;
}

export interface DialogState {
  dialogs: DialogData[];
}

export enum DialogSize {
  XS = "xs",
  SM = "sm",
  MD = "md",
  LG = "lg",
  XL = "xl",
}

const initialState: DialogState = {
  dialogs: [],
};

export const dialogSlice = createSlice({
  name: "dialogSlice",
  initialState,
  reducers: {
    addDialog: (state, action: PayloadAction<DialogData>) => {
      state.dialogs.push(action.payload);
    },
    updateDialog: (
      state,
      action: PayloadAction<{ index: number; dialog: DialogData }>
    ) => {
      state.dialogs[action.payload.index] = action.payload.dialog;
    },
    removeDialog: (state, action: PayloadAction<number>) => {
      state.dialogs.splice(action.payload, 1);
    },
    clearDialogs: (state) => {
      state.dialogs.forEach((dialog) => {
        dialog.open = false;
      });
      state.dialogs = [];
    },
  },
});

export const selectDialogs = (state: RootState) => state.dialog.dialogs;

export const { addDialog, updateDialog, removeDialog, clearDialogs } =
  dialogSlice.actions;
export default dialogSlice.reducer;
